export type PolicySettingsPage = 'policy' | 'returns' | 'approval';

// The server merges these patches; hidden pages must retain their current values.
export const getPolicyPageSaveInput = (
  page: PolicySettingsPage,
  input: Record<string, any>,
): Record<string, any> => {
  const { storeId, policySettings } = input;
  if (page === 'policy') {
    return {
      storeId,
      returnWindow: input.returnWindow,
      shipmentDeadline: input.shipmentDeadline,
      policySettings: { eligibility: policySettings.eligibility },
    };
  }
  if (page === 'returns') {
    return {
      storeId,
      policySettings: {
        returnReasons: policySettings.returnReasons,
        operationalControls: {
          customerExperience: policySettings.operationalControls.customerExperience,
        },
      },
      resolvePortalOptions: input.resolvePortalOptions,
    };
  }
  const controls = policySettings.operationalControls || {};
  const reviewControls = {
    ...(Object.prototype.hasOwnProperty.call(controls, 'inspection') ? {inspection: controls.inspection} : {}),
    ...(Object.prototype.hasOwnProperty.call(controls, 'abuseGuardrails') ? {abuseGuardrails: controls.abuseGuardrails} : {}),
  };
  return {
    storeId,
    ...(input.approval ? { approval: input.approval } : {}),
    refundTiming: input.refundTiming,
    fraudRules: input.fraudRules,
    reasonRules: input.reasonRules,
    policySettings: {
      strictness: policySettings.strictness,
      settlementTiming: policySettings.settlementTiming,
      ...(Object.keys(reviewControls).length ? {operationalControls: reviewControls} : {}),
    },
  };
};
